var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4634)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_4634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5616 5.45833H16.4385L16.4169 5.45833C13.9201 5.45832 11.9317 5.45831 10.3267 5.58944C8.68213 5.72381 7.276 6.00514 5.98723 6.6618C3.90961 7.7204 2.22045 9.40956 1.16184 11.4872C0.505183 12.776 0.223857 14.1821 0.0894901 15.8267C-0.0416424 17.4316 -0.0416351 19.42 -0.0416259 21.9168L-0.0416259 21.9385V22.0615L-0.0416259 22.0832C-0.0416351 24.58 -0.0416424 26.5683 0.0894901 28.1733C0.223857 29.8179 0.505183 31.224 1.16184 32.5128C2.22045 34.5904 3.90961 36.2796 5.98723 37.3382C7.276 37.9949 8.68213 38.2762 10.3267 38.4105C11.9316 38.5417 13.9198 38.5417 16.4163 38.5417H16.4379H16.5616H16.5832C19.0797 38.5417 21.0685 38.5417 22.6734 38.4105C24.3179 38.2762 25.7241 37.9949 27.0129 37.3382C29.0905 36.2796 30.7796 34.5904 31.8382 32.5128C31.8586 32.4728 31.8786 32.4327 31.8983 32.3924C33.8276 33.2335 35.4671 33.929 36.8272 34.298C38.3919 34.7224 40.0397 34.8449 41.5343 33.8669C43.0289 32.8889 43.5766 31.3299 43.8141 29.7262C44.0418 28.1887 44.0418 26.1792 44.0417 23.7817V23.742V20.258V20.2183C44.0418 17.8208 44.0418 15.8113 43.8141 14.2738C43.5766 12.6701 43.0289 11.1111 41.5343 10.1331C40.0397 9.15512 38.3919 9.27755 36.8272 9.70201C35.4671 10.071 33.8276 10.7665 31.8983 11.6076C31.8786 11.5673 31.8586 11.5272 31.8382 11.4872L31.3927 11.7142L31.8382 11.4872C30.7796 9.40956 29.0905 7.7204 27.0129 6.6618C25.7241 6.00514 24.318 5.72381 22.6734 5.58944C21.0684 5.45831 19.08 5.45832 16.5832 5.45833L16.5616 5.45833Z",
    fill: "#99CAE1",
    stroke: "url(#paint0_linear_1_4634)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4634)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5831 13.9515C17.4434 14.3744 18.4868 15.0166 19.7647 15.8031L19.8857 15.8776C21.1649 16.6648 22.2079 17.3067 22.9806 17.8886C23.765 18.4793 24.4451 19.1318 24.8101 20.0058C25.3411 21.277 25.3411 22.723 24.8101 23.9942C24.4451 24.8682 23.765 25.5207 22.9806 26.1114C22.2079 26.6933 21.1649 27.3352 19.8857 28.1224L19.7646 28.197C18.4868 28.9834 17.4434 29.6255 16.5831 30.0485C15.7186 30.4734 14.8185 30.794 13.8711 30.6878C12.5018 30.5344 11.2861 29.7719 10.5088 28.6316C9.98129 27.8576 9.79666 26.9183 9.71069 25.9193C9.62497 24.9234 9.62498 23.6469 9.625 22.0658V21.9341C9.62498 20.3531 9.62497 19.0766 9.71069 18.0807C9.79666 17.0817 9.98129 16.1424 10.5088 15.3684C11.2861 14.2281 12.5018 13.4656 13.8711 13.3122C14.8185 13.206 15.7186 13.5265 16.5831 13.9515ZM14.1773 16.0451C14.3212 16.0289 14.6316 16.0565 15.3699 16.4194C16.0987 16.7777 17.0306 17.3495 18.3846 18.1828C19.738 19.0157 20.6693 19.5906 21.3262 20.0853C21.9833 20.5801 22.1913 20.8712 22.2726 21.0657C22.5203 21.6587 22.5203 22.3413 22.2726 22.9343C22.1913 23.1288 21.9833 23.4199 21.3262 23.9147C20.6693 24.4094 19.738 24.9843 18.3846 25.8172C17.0306 26.6505 16.0987 27.2223 15.3699 27.5805C14.6316 27.9435 14.3212 27.971 14.1773 27.9549C13.6428 27.895 13.1291 27.5932 12.7812 27.0827C12.6637 26.9104 12.5258 26.5581 12.4506 25.6835C12.3762 24.8197 12.375 23.6624 12.375 22C12.375 20.3376 12.3762 19.1802 12.4506 18.3165C12.5258 17.4419 12.6637 17.0896 12.7812 16.9172C13.1291 16.4068 13.6428 16.1049 14.1773 16.0451Z",
    fill: "url(#paint1_linear_1_4634)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_4634",
    x: -24.5416,
    y: -19.0417,
    width: 93.0834,
    height: 82.0833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4634",
    x: 6.625,
    y: 10.2917,
    width: 31.5834,
    height: 33.4166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4634",
    x1: 0.458374,
    y1: 5.95833,
    x2: 31.2209,
    y2: 47.2261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4634",
    x1: 17.5479,
    y1: 34.4188,
    x2: 41.385,
    y2: 13.5121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.4aa8fe7dadc77537361ab3004cdd9c51.svg";
export { ForwardRef as ReactComponent };